import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ mensaje = 'Cargando...' }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-box">
        <div className="loading-bubbles">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <p className="loading-texto">{mensaje}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
